import { Box, Typography } from "@mui/material";
import React from "react";
import styled from "@emotion/styled";
import { toCurrency } from "@helpers";
import { GainLossTypography, YTDPercents, Card as CardOrg } from "@components";
import { ProgressCircle } from "@components/ProgressCircle";
import { AssetTypeCardLoading } from "./AssetTypeCardLoading";

const Marker = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

const ProgressCircleStyled = styled(ProgressCircle)`
  cursor: grab;
`;

const PercentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const Card = styled(CardOrg)`
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing(2, 3)};
  cursor: grab;
  border-radius: 8px;
  height: 120px;
  width: 270px;
`;

export interface Props {
  isFetching?: boolean;
  title: string;
  amount?: string;
  percent?: number;
  increase?: number;
  changeAbs?: number;
  color: string;
  onClick?: () => void;
}

export const AssetTypeCard = ({
  percent,
  onClick,
  title,
  amount,
  increase,
  changeAbs,
  color,
  isFetching = false,
}: Props) => {
  if (isFetching) {
    return <AssetTypeCardLoading />;
  }

  return (
    <Card size="micro" onClick={onClick}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        mb={4}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Marker color={color} />
          <Typography variant="body3" color="textSecondary">
            {title}
          </Typography>
        </Box>
        <PercentWrapper>
          {increase != undefined && <YTDPercents value={increase} />}
        </PercentWrapper>
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <Box ml={-1}>
          {percent != undefined && <ProgressCircleStyled percent={percent} />}
        </Box>
        <Box>
          <Typography variant="h5" noWrap mb={1}>
            {amount}
          </Typography>
          {changeAbs != undefined && (
            <GainLossTypography value={changeAbs} variant="body4" showIndicator>
              {toCurrency(changeAbs, "EUR")}
            </GainLossTypography>
          )}
        </Box>
      </Box>
    </Card>
  );
};
